import type { ComponentProps } from "react"

export default function Tag(props: ComponentProps<"svg"> & { fill?: string }) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 256 256"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path d="M250,121.34,204.36,52.91A20,20,0,0,0,187.72,44H40A20,20,0,0,0,20,64V192a20,20,0,0,0,20,20H187.72a20,20,0,0,0,16.64-8.91L250,134.66A12,12,0,0,0,250,121.34ZM185.58,188H44V68H185.58l40,60Z" />
    </svg>
  )
}
